/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { createContext } from 'react';
export interface PLP_STATE {
	open: boolean;
	total: number | string;
	breadCrumbs: BreadcrumbsType[];
}

export enum PLP_ACTIONS_TYPES {
	SET_OPEN = 'SET_OPEN',
	SET_TOTAL = 'SET_TOTAL',
	SET_BREADCRUMBS = 'SET_BREADCRUMBS',
}
export type PLP_ACTIONS =
	| { type: PLP_ACTIONS_TYPES.SET_OPEN; payload: boolean }
	| { type: PLP_ACTIONS_TYPES.SET_TOTAL; payload: number | string }
	| { type: PLP_ACTIONS_TYPES.SET_BREADCRUMBS; payload: BreadcrumbsType[] };
export interface BreadcrumbsType {
	label: string;
	value?: string;
	type?: string;
	href?: string;
}
interface ContextModalType {
	state: PLP_STATE;
	onSetTotal: (total: number | string) => void;
	onSetOpen: (open: boolean) => void;
	onSetBreadCrumbs: (breadCrumbs: BreadcrumbsType[]) => void;
}
export const ContentContext = createContext<unknown>({});
export const ContentProvider = ContentContext.Provider;
export const ContextModal = createContext<ContextModalType | undefined>(undefined);

export const SliderContext = createContext<{ mouseMoved: boolean }>({ mouseMoved: false });
export const SliderProvider = SliderContext.Provider;

export const MarksSliderContext = createContext<{ mouseMoved: boolean }>({ mouseMoved: false });
export const MarksSliderProvider = MarksSliderContext.Provider;
